import { isEmpty } from 'lodash';
import {
  IntegrationOperationType,
  useIntegrationMetadataContext,
} from 'modules/mobileApps/context/integrationMetadata';
import { ModalType, useModalContext } from 'modules/mobileApps/context/modal';
import { STATE, selectAreAllIntegrationSlotsAssigned } from 'modules/mobileApps/selectors';
import { AppPlatform, IntegrationPlatform } from 'modules/mobileApps/types';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';
import { BUTTON_VARIANTS, Button } from 'ui/button';
import removeAllSpaces from 'utils/removeAllSpaces';
import {
  DetailsTitle,
  SectionHeader,
  SectionTitle,
  StyledBox,
  StyledDetailsHeader,
  StyledSection,
  StyledSectionContent,
} from '../AppDetails.styled';
import { IntegrationTable } from '../IntegrationTable';
import { StyledAddIcon } from './AssignedIntegrations.styled';

export const AssignedIntegrations = () => {
  const { appDetails, assignedIntegrations, setOperationType, setSelectedIntegration } =
    useIntegrationMetadataContext();
  const { openModal } = useModalContext();

  const { id }: { id: string } = useParams();
  const allIntegrationsAreAssigned = useSelector((state: STATE) =>
    selectAreAllIntegrationSlotsAssigned(state, { id }),
  );

  const isIosPlatform = appDetails?.platform === AppPlatform.IOS;

  const handleCreateIntegrationClick = () => {
    if (!appDetails) return;

    setOperationType(IntegrationOperationType.CREATE);
    setSelectedIntegration({
      name: removeAllSpaces(appDetails.packageName),
      platform: IntegrationPlatform.APNS,
    });
    openModal(ModalType.ConfigureIosIntegrationModal);
  };

  const getPushDescription = () => {
    if (isIosPlatform)
      return `Configure and edit ${appDetails.platform} authentication credentials`;
    if (allIntegrationsAreAssigned) return 'Manage the integrations assigned to your app.';
    return 'Set up new push integrations by uploading certificates and keys.';
  };

  return (
    <StyledSection data-test="mobileApps-AssignedIntegrations">
      <SectionHeader>
        <SectionTitle>Push {isIosPlatform && 'Credentials'}</SectionTitle>
        {getPushDescription()}
      </SectionHeader>
      <StyledSectionContent>
        <StyledBox id="styled-box">
          <StyledDetailsHeader>
            {isIosPlatform ? (
              <Button
                data-test="assigned-integrations-add-credential-button"
                onClick={handleCreateIntegrationClick}
                variant={
                  isEmpty(assignedIntegrations)
                    ? BUTTON_VARIANTS.PRIMARY
                    : BUTTON_VARIANTS.SECONDARY
                }
              >
                <StyledAddIcon /> Add new credential
              </Button>
            ) : (
              <DetailsTitle>Integrations</DetailsTitle>
            )}
          </StyledDetailsHeader>
          <IntegrationTable />
        </StyledBox>
      </StyledSectionContent>
    </StyledSection>
  );
};
